// src/slices/branchesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TotalPagesState {
  count: number;
}

const initialState: TotalPagesState = {
  count: 1
};

const TotalPagesSlice = createSlice({
  name: 'totalpages',
  initialState,
  reducers: {
    updateCount: (state: TotalPagesState, action: PayloadAction<number>) => {
      state.count = action.payload;
    }
  }
});

export const { updateCount } = TotalPagesSlice.actions;
export default TotalPagesSlice.reducer;
